import React, { useState, useEffect } from "react";
import "./Magazines.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import { MdSearch } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import BottomBar from "../../Components/BottomBar/BottomBar";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Magazines() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [activeBtnId, setActiveBtnId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [magazines, setMagazines] = useState([]);
  const [searchInputVal, setSearchInputVal] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [bannerBg, setBannerBg] = useState("/images/bgLogo.svg");
  const [visibleMagazines, setVisibleMagazines] = useState([]);

  useEffect(() => {
    if (isSearching && searchInputVal && searchResult.length > 0) {
      setVisibleMagazines(searchResult);
    } else if (categories.length > 0 && magazines.length > 0) {
      setVisibleMagazines(magazines);
    }
  }, [magazines, isSearching, searchInputVal, searchResult]);

  useEffect(() => {
    if (visibleMagazines.length > 0 && visibleMagazines[0].cover) {
      setBannerBg(visibleMagazines[0].cover);
    }
  }, [visibleMagazines]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const activeNavBtnHandler = (categoryId) => {
    setActiveBtnId(categoryId);
    setIsSearching(false);
  };

  const openMagazineHandler = async (magazine) => {
    navigate("/magazine", { state: { magazineId: magazine.id } });
  };

  useEffect(() => {
    const fetchMagazines = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/keywords/${activeBtnId}`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setMagazines(response.data.journals);
      } catch (error) {
        console.log("Error during getting magazines data request", error);
      }
    };
    if (userToken && activeBtnId) {
      fetchMagazines();
    }
  }, [baseUrl, activeBtnId]);

  useEffect(() => {
    const fetchMagazineCategories = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/keywords`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setActiveBtnId(response.data.keywords[0].id);
        setCategories(response.data.keywords);
      } catch (error) {
        console.log("Error during getting magazines data request", error);
      }
    };
    if (userToken) {
      fetchMagazineCategories();
    }
  }, [baseUrl]);

  const handleSearch = async (e) => {
    let inputValue = e.target.value;
    setSearchInputVal(inputValue);
    setIsSearching(true);
    try {
      const response = await Axios.get(
        `${baseUrl}/journals?search=${inputValue}`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setSearchResult(response.data.journals);
    } catch (error) {
      console.log("Error during getting search result", error);
    }
  };

  const handleBannerClick = () => {
    if (visibleMagazines.length > 0) {
      openMagazineHandler(visibleMagazines[0]);
    }
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="pageTitle horizontalBorder">مجله ورزشی</h3>
          <div className="magazinesScrollWrapper scroll">
            <div className="searchContainer responsiveWidth">
              <input
                type="search"
                placeholder="کلمه مورد نظر خود را سرچ کنید"
                className="searchInput"
                value={searchInputVal}
                onChange={handleSearch}
              />
              <MdSearch className="searchIcon" />
            </div>
            <div className="magazinesBanner">
              <LazyLoadImage
                width="100%"
                height="100%"
                src={bannerBg || "/images/bgLogo.svg"}
                alt="magazine banner"
                effect="opacity"
                placeholderSrc="/images/bgLogo.svg"
                style={{
                  backgroundRepeat: "no-repeat",
                  borderRadius: "0.625",
                }}
                onError={({ target }) => {
                  target.onerror = null;
                  target.src = "/images/bgLogo.svg";
                }}
              />
              <button
                className="magazinesBannerBtn centeredFlex"
                onClick={handleBannerClick}
              >
                <MdArrowForwardIos className="magazinesArrowIcon" />
                <span>ادامه مطلب</span>
              </button>
            </div>

            <div className="magazinesNavMenu scroll centeredFlex responsiveWidth">
              {categories.length > 0 &&
                categories.map((category) => (
                  <button
                    key={category.id}
                    className={`magazinesNavMenuItem ${
                      category.id === activeBtnId ? "activeNavBtn" : ""
                    }`}
                    onClick={() => activeNavBtnHandler(category.id)}
                  >
                    {category.word}
                  </button>
                ))}
            </div>
            <div className="magazines responsiveWidth">
              {visibleMagazines.length > 0 &&
                visibleMagazines.map((magazine) => (
                  <div
                    onClick={() => openMagazineHandler({ ...magazine })}
                    key={magazine.id}
                    className="magazinesCard centeredFlex"
                  >
                    <div className="magazinesCardImg">
                      <LazyLoadImage
                        width="100%"
                        height="100%"
                        src={magazine.cover || "/images/bgLogo.svg"}
                        alt={magazine.title || "magazine"}
                        effect="opacity"
                        placeholderSrc="/images/bgLogo.svg"
                        style={{
                          borderRadius: "0 0.6875rem 0.6875rem 0",
                        }}
                        onError={({ target }) => {
                          target.onerror = null;
                          target.src = "/images/bgLogo.svg";
                        }}
                      />
                    </div>
                    <div className="magazinesCardContent centeredFlex">
                      <h3>{magazine.title}</h3>
                      <div className="magazinesCardBottom centeredFlex">
                        <div className="magazinesCategory centeredFlex">
                          <img src="/images/smallLogo.jpg" alt="redrose icon" />
                          {magazine.keyword.length > 0 && (
                            <span>{magazine.keyword[0].word}</span>
                          )}
                        </div>
                        <button>خواندن</button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
